export const ExperimentAPINames = {
  ArchiveWall: "Archive Wall",
};
